export const SELECT_ALL_VALUE = '__SELECT_ALL__';
